module.exports = __webpack_public_path__ + "img/prefeitura-logo.66aed7f6.png";